import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OmixatlasApiService, DatalakeApiService, ElasticApiResponse, ElasticFilters } from 'polly-commons';
import { ProcessedDataQueryResponse, ProcessedDataResponseV2, StringToStringObjectMapping } from '../../../polly-manage.interfaces';
import { CreateQueryPayload, QueryDownloadFileResponse } from '../../../@core/interfaces/apis.interface';
import { atlasApiEndpoint } from '../constants/omixatlas.constants';
import { Aggregations } from '../../../@core/interfaces/dataset-filters.interface';

@Injectable({
  providedIn: 'root',
})

export class PollyOmixatlasGdxService {
  constructor( 
    private readonly omixatlasApi: OmixatlasApiService,
    private readonly datalakeApi: DatalakeApiService,
     ) {}

  public createQuery(datasetId: string, repoName: string, isHeatMapQuery: boolean = false,selector: string = '*', whereQuery: string = ''): Observable<ProcessedDataQueryResponse> {
    if (datasetId.includes('_raw')) {
      datasetId = datasetId.replace('raw', isHeatMapQuery ? 'heatmap' : 'pca');
    }
    else {
      datasetId += `_${isHeatMapQuery ? 'heatmap' : 'pca'}`;
    }
    const query: string = `SELECT ${selector} FROM data_matrices.${repoName}__${datasetId} ${whereQuery}`;
    const payload: CreateQueryPayload = {
      'data': {
        'type': 'queries',
        'attributes': {
          'query': `${query}`,
          'query_api_version': 'v2',
          'query_results_format': 'CSV'
        }
      }
    }
    return this.omixatlasApi.post(atlasApiEndpoint.QUERY_BASE, payload);
  }

  public checkQueryStatus(queryId: string): Observable<ProcessedDataQueryResponse> {
    return this.omixatlasApi.get(`${atlasApiEndpoint.QUERY_BASE}/${queryId}`);
  }

  public getQueriesResult(data: {queryId: string, nextLink: string }): Observable<ProcessedDataResponseV2> {
    if (data.nextLink) {
      return this.omixatlasApi.get(data.nextLink);
    } else {
      return this.omixatlasApi.get(`${atlasApiEndpoint.QUERY_BASE}/${data.queryId}/results?page[size]=999`);
    }
  }

  public downloadQueryFile(queryId: string): Observable<QueryDownloadFileResponse> {
    return this.omixatlasApi.get(`${atlasApiEndpoint.QUERY_BASE}/${queryId}/results?action=download&file_size=true`);
  }

  public getCatagories(indexName: string, payload: ElasticFilters): any {
    return this.datalakeApi.post(`elastic/v2/${indexName}/_search/?gdx=true`, payload);
  }

  public getPathways(indexName: string, payload: ElasticFilters): Observable<ElasticApiResponse<StringToStringObjectMapping,Aggregations>> {
    return this.datalakeApi.post(`elastic/v2/${indexName}/_search/?gdx=true`, payload);
  }
}
